import React from 'react';
import { Menu, MenuProps } from 'antd';
import { useTranslation, TFunction } from 'react-i18next';
import { Link } from 'react-router-dom';
import getConfig from 'configs/getConfig';

const config = getConfig();
export const getHelpMenuItems = (t: TFunction, changeStatus: () => void): MenuProps['items'] => [
  {
    label: <Link to="/enquiry">{t('header.helpMenu.enquiry')}</Link>,
    key: 'enquiry',
  },
  {
    label: <Link to="/faq">{t('header.helpMenu.faq')}</Link>,
    key: 'faq',
  },
  {
    // label: <Link to="/user-guide">{t('header.helpMenu.userGuide')}</Link>,
    label: (
      <a
        target="_blank"
        rel="noreferrer"
        onClick={changeStatus}
        href={`${config.userGuideUrl}${t('header.helpMenu.pdfLanguage')}.pdf`}
      >
        {t('header.helpMenu.userGuide')}
      </a>
    ),
    key: 'user-guide',
  },
];

export const HelpMenu = (props: { changeOpen?: (status: boolean) => void }): JSX.Element => {
  const { t } = useTranslation();
  const changeStatus = () => {
    if (props.changeOpen) props.changeOpen(false);
  };
  return <Menu items={getHelpMenuItems(t, changeStatus)} />;
};
